<template>
    <layout title="News">
        <settings-layout>
            <news-list :items="items"></news-list>
        </settings-layout>
    </layout>
</template>

<script>
import Layout from '@/Shared/Layout'
import NewsList from '@/Components/News/NewsList'
import SettingsLayout from "./SettingsLayout";

export default {
    components: {SettingsLayout, NewsList, Layout },
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    metaInfo() {
        return {
            title: `Settings`,
        }
    },
}
</script>
